export default __webpack_public_path__ + "assets/5e0bcbe28be0345dd4d89d0612d986ba.png";